// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","563":"cb355538"}[chunkId] || chunkId) + "-" + {"245":"a5e86b023b8761fe7dc9","454":"bf3137598a0ff1492c91","563":"ad4c20797b3e52f6e8cf"}[chunkId] + ".js";
};